
import clsx from "clsx";

export interface CardProps {
  hover?: boolean;
  interactive?: boolean;
  shadow?: boolean;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export function Card({
  hover = false,
  interactive = false,
  shadow = false,
  children,
  className,
  onClick,
}: CardProps) {
  const classes = clsx(
    interactive
      ? "card-interactive"
      : hover
      ? "card-hover"
      : shadow
      ? "card-shadow"
      : "card",
    className
  );

  return (
    <div className={classes} onClick={onClick}>
      {children}
    </div>
  );
}

export default Card;
